export const REGEX_DECIMAL_WITH_TWO_DIGITS = /^-?(0||[1-9][0-9]*)(\.[0-9]{1,2})?$/;
export const REGEX_POSITIVE_DECIMAL_WITH_TWO_DIGITS = /^[0-9]+(\.([0-9]){1,2})?$/;
export const REGEX_POSITIVE_NUMBER = /^[0-9]*$/;
export const REGEX_POSITIVE_NUMBER_OR_EMPTY = /^(\s*|\d+)$/;
